/** Thumbnail sizes the Worker will serve; anything else falls back to the original. */
export type PhotoSize = 400 | 1200 | 0;

/**
 * Photo URLs are authorized per user, not public.
 *
 * Blob ids are content hashes and are shared across households after an import, so the
 * Worker checks that the caller belongs to a household the blob was granted to before it
 * streams anything. A blob id alone must never be enough to read someone's photo.
 */
export function photoUrl(apiBaseUrl: string, blobId: string, size: PhotoSize = 400): string {
  const query = size === 0 ? '' : `?size=${size}`;
  return `${apiBaseUrl}/api/blobs/${blobId}${query}`;
}

/**
 * A tiny inline placeholder shown while a photo loads, or in place of one whose bytes have
 * not been uploaded yet. Rendering a broken image for an offline-captured photo would look
 * like data loss when nothing is actually wrong.
 */
export const PHOTO_PLACEHOLDER =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"><rect width="8" height="8" fill="#e8e2d9"/></svg>',
  );
